import { useContext } from 'react';

import { CompetitorTypeContext } from 'contexts/CompetitorTypeContext';

export const useCompetitorsType = () => {
  const context = useContext(CompetitorTypeContext);

  if (context === undefined) {
    throw new Error('useCompetitorsType must be used within the CompetitorTypeProvider');
  }

  return context;
};
